import Vue from 'vue'
import App from './App.vue'
import store from './store'
import PubSub from './PubSub'

import './events'

Vue.config.productionTip = false

Vue.prototype.$PubSub = PubSub

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js